import React, { useState, useEffect } from 'react';
import Styles from './NewsTwo.module.css';
import DownTown from '../../../images/News/Avis - Tbilisi Downtown - Copy.jpg';
import Airport from '../../../images/News/Avis - Tbilisi Airport.jpg';

function NewsTwo() {
  const [zoomedImage, setZoomedImage] = useState(null);

  // Escape ღილაკით დახურვა
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setZoomedImage(null);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  const toggleZoom = (imageName) => {
    setZoomedImage(prev => (prev === imageName ? null : imageName));
  };

  return (
    <div className={Styles.main_page}>
      <h1>2024 WINNER COMPANY</h1>

      <div className={Styles.min_image}>
        <div className={Styles.secend_image}>
          <img
            src={DownTown}
            alt="DownTown"
            onClick={() => toggleZoom("downtown")}
            className={Styles.zoomThumb}
          />
        </div>

        <div className={Styles.secend_image}>
          <img
            src={Airport}
            alt="Airport"
            onClick={() => toggleZoom("airport")}
            className={Styles.zoomThumb}
          />
        </div>
      </div>

      <p>
        We are evaluated by a huge global broker Rentalcars.com as the best car rental company in Georgia in
        2023 and 2024. Customer Favorite Awards granted.
      </p>

      {/* მოდალი თუ ზუმირებული სურათი არსებობს */}
      {zoomedImage && (
        <div className={Styles.modalOverlay} onClick={() => setZoomedImage(null)}>
          <div className={Styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <button className={Styles.closeButton} onClick={() => setZoomedImage(null)}>×</button>
            <img
              src={zoomedImage === 'downtown' ? DownTown : Airport}
              alt="Zoomed"
              className={Styles.modalImage}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default NewsTwo;
